import { StatusColorMap, StatusLabelMap } from "../../../shared/components/chips/StatusChip";
import colors from "../../../shared/themes/colors";
import { ServiceRequestStatusCode } from "../models/models";
import { dt } from "../../../shared/themes/redesignTokens";

export const createStatusLabelMap = (translate: (key: string) => string): StatusLabelMap<ServiceRequestStatusCode> => ({
  [ServiceRequestStatusCode.draft]: translate("draft"),
  [ServiceRequestStatusCode.openForOffers]: translate("openForOffers"),
  [ServiceRequestStatusCode.negotiating]: translate("negotiating"),
  [ServiceRequestStatusCode.inProgress]: translate("inProgress"),
  [ServiceRequestStatusCode.completed]: translate("completed"),
  [ServiceRequestStatusCode.archived]: translate("archived"),
  [ServiceRequestStatusCode.awaitingProviderConfirmation]: translate("awaitingProviderConfirmation"),
  [ServiceRequestStatusCode.awaitingCompletionConfirmation]: translate("awaitingCompletionConfirmation"),
});

export const createStatusColorMap = (): StatusColorMap<ServiceRequestStatusCode> => ({
  [ServiceRequestStatusCode.draft]: {
    backgroundColor: colors.backgrounds.violet,
    textColor: colors.icons.violet
  },
  [ServiceRequestStatusCode.openForOffers]: {
    backgroundColor: colors.primary.lightBlue3,
    textColor: dt.blue
  },
  [ServiceRequestStatusCode.negotiating]: {
    backgroundColor: colors.backgrounds.orange,
    textColor: colors.icons.orange
  },
  [ServiceRequestStatusCode.inProgress]: {
    backgroundColor: colors.secondary.gray94,
    textColor: colors.secondary.gray40
  },
  [ServiceRequestStatusCode.completed]: {
    backgroundColor: colors.backgrounds.green,
    textColor: colors.primary.green
  },
  [ServiceRequestStatusCode.archived]: {
    backgroundColor: colors.secondary.gray94,
    textColor: colors.secondary.gray40
  },
  [ServiceRequestStatusCode.awaitingProviderConfirmation]: {
    backgroundColor: "#FEF9E7",
    textColor: "#F39C12"
  },
  [ServiceRequestStatusCode.awaitingCompletionConfirmation]: {
    backgroundColor: colors.backgrounds.orange,
    textColor: colors.icons.orange
  }
});
